import styled from 'styled-components';
import { Col } from 'antd';

export const DefaultResultContent = styled(Col)`
	gap: 48px;
	display: flex;
	padding: 40px;
	border-radius: 24px;
	flex-direction: column;
	background-color: ${({ theme }) => theme.palette.secondary.white};
`;
